import { registerBlockType } from "@wordpress/blocks";
import config, { BlockAttributes } from "./block.json";
import DownloadLinkSave from "./DownloadLinkSave";
import DownloadLinkEditor from "./DownloadLinkEditor";

registerBlockType<BlockAttributes>(config.name, {
  ...config,

  edit: DownloadLinkEditor,
  save: DownloadLinkSave,
});
